import fetchWrapper from "../../utils/fetchWrapper";

const programNumberSearchService = () => {
  const search = async(query) => {
    const url = `api/programs/search?query=${query}`;
    const data = await fetchWrapper({url});
    return data;
  }
  return {search};
}

export default programNumberSearchService;